import createModule from "../createModule"
import view from "./view"
import { size } from "lodash"
import { Creators } from "./model"
import { getStartDate, getSelectedTypeName, getAnalyzeMenuItems, getHasUnexpandedComposites, getAiSummaryStartDate } from "./selectors"
import { getIsHasUnexpandedCompositesLoading } from "selectors/data"
import { getEndDate } from "selectors/dates"
import { getContentSets } from "selectors/contentSets"
import { getIsPortfolioFiltersLoading } from "selectors/portfolios"
import { getAiTermsAccepted } from "modules/account-root/selectors"
import { getSelectedModelId, getIsExpanded } from "modules/portfolio-root/selectors/portfolios"
import { generateClassificationQuery, classificationsQuery } from "helpers/classification"
import { getFilterOns, getClassificationsTiers, getChipSecuritiesIds, getHasUnsupportedContributionFilter, getAddedFilters } from "./selectors/filters"
import { getAdjustedNormalizationProperties } from "./selectors/normalization"
import { Creators as PortfolioCreators } from "modules/portfolio-root/model"
import { MODEL_METADATA_QUERY } from "resources/models"
import "./style.scss"

export default createModule({
  view,
  externalProps: (state, props) => ({
    contentSets: getContentSets(state, props),
    account: state.global.selected.account,
    modelId: getSelectedModelId(state, props),
    portfolioId: state.global.selected.portfolio,
    classificationsTiers: getClassificationsTiers(state, props),
    securitiesIds: getChipSecuritiesIds(state, props),
    startDate: getStartDate(state, props),
    endDate: getEndDate(state, props),
    isExpanded: getIsExpanded(state, props),
  }),
  required: ["account", "modelId"],
  data: [{
    resource: "portfolioFilters",
    as: null,
    passthrough: true,
    url: ({ account, modelId, portfolioId, startDate, endDate, isExpanded }) => `/api/${account}/m/${modelId}/r/portfolio/${portfolioId}/filters?startDate=${startDate}&endDate=${endDate}&expand=${isExpanded}`,
  }, {
    resource: "classifications",
    as: null,
    url: () => ({
      id: "classifications",
      query: classificationsQuery,
    }),
  }, {
    resource: "classificationsValues",
    as: null,
    url: ({ classificationsTiers, startDate }) => {
      if (size(classificationsTiers) === 0 || !startDate) {
        return null
      }

      // We don't know the depth of each classification, generate each classification sub query according to the tier depth
      const innerQuery = generateClassificationQuery(classificationsTiers)
      return {
        id: `classificationsValues-${startDate}-${JSON.stringify(classificationsTiers)}`,
        query: `query {
            ${innerQuery}
          }`,
      }
    },
  }, {
    resource: "portfolioSecuritiesDescriptors",
    url: ({ account, modelId, securitiesIds, endDate }) => {
      if (size(securitiesIds) === 0) {
        return null
      }

      return {
        url: `/api/${account}/m/${modelId}/securities/descriptors?date=${endDate}`,
        id: `securitiesDescriptors${account}${modelId}${endDate}${JSON.stringify(securitiesIds)}`,
        payload: { ids: securitiesIds },
      }
    },
  }, {
    resource: "hasUnexpandedComposites",
    passthrough: true,
    url: ({ account, portfolioId, modelId, startDate, endDate }) => `/api/${account}/p/${portfolioId}/${modelId}/unexpanded-composites?from=${startDate}&to=${endDate}`,
  },
  MODEL_METADATA_QUERY,
  ],
  mapStateToProps: (state, props) => ({
    ...state.modules.analyzeHeader,
    menuItems: getAnalyzeMenuItems(state, props),
    selectedTypeName: getSelectedTypeName(state, props),
    filterOns: getFilterOns(state, props),
    addedFilters: getAddedFilters(state, props),
    hasUnexpandedComposites: getHasUnexpandedComposites(state, props),
    hasUnsupportedContributionFilter: getHasUnsupportedContributionFilter(state, props),
    isAiTermsAccepted: getAiTermsAccepted(state, props),
    aiSummaryStartDate: getAiSummaryStartDate(state, props),
    isPortfolioFiltersLoading: getIsPortfolioFiltersLoading(state, props),
    isHasUnexpandedCompositesLoading: getIsHasUnexpandedCompositesLoading(state, props),
    ...getAdjustedNormalizationProperties(state, props),
  }),
  actions: {
    ...Creators,
    setExpansionMode: PortfolioCreators.setExpansionMode,
  },
})
